import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import {controlPropTypes} from "../formhelpers";
import PropTypes from "prop-types";

export default class Label extends React.Component {
    render() {
        const {descriptor, value} = this.props;
        const valueStr = ArmusScript["numberFormat(Number,String)"](value, descriptor.config.mask) || "";
        return (
            <ControlTemplate {...this.props} className="decimal-field" >
                <span>{valueStr}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = controlPropTypes({
    mask: PropTypes.string.isRequired
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/DecimalField/label.js